import { Action } from 'redux';

import {
    ActionType,
    FormSaveAction,
    FormSaveResultAction,
    FormSetReadonlyAction,
    FormValueChangeAction,
    PrintRetrieveInitDataAction,
    PrintRetrieveInitDataResultAction,
    ReportFormValueChangeAction,
    ReportGenerateAction,
    ReportGenerateResultAction,
    ReportRetrieveInitDataAction,
    ReportRetrieveInitDataResultAction,
    RetrieveInitDataAction,
    RetrieveInitDataResultAction,
} from './tdcf-form.action';
import { defaultState, State } from './tdcf-form.state';

const reducerFns: {
    [key: string]: (state: State, action: Action<ActionType>) => State;
} = {
    [ActionType.TDCF_FORM__RETRIEVE_INIT_DATA](
        state,
        action: RetrieveInitDataAction,
    ): State {
        return {
            ...defaultState(),
            pending: true,
            metadata: undefined,
            info: undefined,
            table: {
                ...state.table,
                me: undefined,
                team: undefined,
            },
        };
    },
    [ActionType.TDCF_FORM__RETRIEVE_INIT_DATA_RESULT](
        state,
        action: RetrieveInitDataResultAction,
    ): State {
        return {
            ...state,
            pending: false,
            metadata: action.metadata,
            info: action.info,
            hierarchy: action.hierarchy,
            table: {
                ...state.table,
                me: action.me,
                team: action.team,
            },
        };
    },
    [ActionType.TDCF_FORM__FORM_VALUE_CHANGE](
        state,
        action: FormValueChangeAction,
    ): State {
        return {
            ...state,
            form: {
                ...state.form,
                [action.key]: {
                    ...state.form[action.key],
                    formValue: action.value,
                },
            },
        };
    },
    [ActionType.TDCF_FORM__FORM_SAVE](state, action: FormSaveAction): State {
        const def =
            (!state.form[action.key]
                ? null
                : state.form[action.key].formValue ||
                  state.form[action.key].payload) || {};
        return {
            ...state,
            form: {
                ...state.form,
                [action.key]: {
                    ...state.form[action.key],
                    pending: true,
                    formValue: {
                        ...state.form[action.key].formValue,
                        lookingBack:
                            action.data.payload.lookingBack || def.lookingBack,
                        lookingForward:
                            action.data.payload.lookingForward ||
                            def.lookingForward,
                        conversationSummary:
                            action.data.payload.conversationSummary ||
                            def.conversationSummary,
                    },
                },
            },
        };
    },
    [ActionType.TDCF_FORM__FORM_SAVE_RESULT](
        state,
        action: FormSaveResultAction,
    ): State {
        const pl = !action.payload
            ? state.form[action.key].payload
            : action.payload;
        return {
            ...state,
            form: {
                ...state.form,
                [action.key]: {
                    ...state.form[action.key],
                    pending: false,
                    payload: pl,
                },
            },
        };
    },
    [ActionType.TDCF_FORM__FORM_SET_READONLY](
        state,
        action: FormSetReadonlyAction,
    ): State {
        return {
            ...state,
            form: {
                ...state.form,
                [action.key]: {
                    ...state.form[action.key],
                    readonly: action.readonly,
                },
            },
        };
    },
    [ActionType.TDCF_FORM__FORM_RESET_STATE](state, action: any): State {
        return {
            ...state,
            form: {
                ...state.form,
                [action.key]: { readonly: true },
            },
        };
    },
    [ActionType.TDCF_FORM__PRINT_RETRIEVE_INIT_DATA](
        state,
        action: PrintRetrieveInitDataAction,
    ): State {
        return {
            ...state,
            printPreview: {
                ...state.printPreview,
                pending: true,
                metadata: undefined,
                payload: undefined,
            },
        };
    },
    [ActionType.TDCF_FORM__PRINT_RETRIEVE_INIT_DATA_RESULT](
        state,
        action: PrintRetrieveInitDataResultAction,
    ): State {
        return {
            ...state,
            printPreview: {
                ...state.printPreview,
                pending: false,
                metadata: action.metadata,
                payload: action.payload,
            },
        };
    },
    [ActionType.TDCF_FORM__REPORT_RETRIEVE_INIT_DATA](
        state,
        action: ReportRetrieveInitDataAction,
    ): State {
        return {
            ...defaultState(),
            managerReport: {
                pendingMetadata: true,
                metadata: undefined,
            },
        };
    },
    [ActionType.TDCF_FORM__REPORT_RETRIEVE_INIT_DATA_RESULT](
        state,
        action: ReportRetrieveInitDataResultAction,
    ): State {
        return {
            ...state,
            managerReport: {
                ...state.managerReport,
                pendingMetadata: false,
                metadata: action.metadata,
            },
        };
    },
    [ActionType.TDCF_FORM__REPORT_FORM_VALUE_CHANGE](
        state,
        action: ReportFormValueChangeAction,
    ): State {
        return {
            ...state,
            managerReport: {
                ...state.managerReport,
                formValue: action.value,
            },
        };
    },
    [ActionType.TDCF_FORM__REPORT_GENERATE](
        state,
        action: ReportGenerateAction,
    ): State {
        return {
            ...state,
            managerReport: {
                ...state.managerReport,
                pendingData: true,
                table: {
                    ...state.managerReport.table,
                    data: undefined,
                },
            },
        };
    },
    [ActionType.TDCF_FORM__REPORT_GENERATE_RESULT](
        state,
        action: ReportGenerateResultAction,
    ): State {
        return {
            ...state,
            managerReport: {
                ...state.managerReport,
                pendingData: false,
                table: {
                    ...state.managerReport.table,
                    data: action.data,
                },
            },
        };
    },
};

export const tdcfForm = (
    state: State = defaultState(),
    action: Action<ActionType>,
): State => {
    const fn = reducerFns[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
